// MusicPageSettingServices.js
import API from "../../api/apiAdmin";

export const MusicPageSettingServices = {
    getSettings: async () => {
        try {
            const response = await API.get("/admin/music-settings/");
            return response.data;
        } catch (error) {
            throw error.response ? error.response.data : new Error("Network error");
        }
    },

    updateSettings: async (formData) => {
        try {
            const response = await API.put("/admin/music-settings/", formData);
            return response.data;
        } catch (error) {
            throw error.response ? error.response.data : new Error("Network error");
        }
    }
};
